
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/layman-explanation",
      function () {
        return require("private-next-pages/layman-explanation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/layman-explanation"])
      });
    }
  